import { Navigate, Outlet } from 'react-router-dom'
import { useSession } from '../store/sessionContext'

export default function RequireAuth() {
  const { session, loading } = useSession()
  if (loading) return null
  return session ? <Outlet /> : <Navigate to="/login" />
}
